import React, { createContext, useContext } from 'react';

const SchoolIdContext = createContext();

export const useSchoolId = () => useContext(SchoolIdContext);

export default SchoolIdContext;